
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/pwa.css';
import './styles/effects.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
